<template>
    <label :class="[$style['cool-radio'], 'cool-radio']" tabindex="0">
        <slot></slot>
        <div></div>
    </label>
</template>

<style module>
label.cool-radio {
    display: inline-block !important;
    vertical-align: middle;
    outline: 0;
}

label.cool-radio > input[type="radio"] {
    position: absolute;
    width: 16px;
    height: 16px;
    display: inline-block;
    padding: 0;
    margin: 0;
    opacity: 0;
    z-index: -1;
}

label.cool-radio > input[type="radio"] + div {
    width: 16px;
    height: 16px;
    cursor: pointer;
    background-image: url("./radio.png");
    display: inline-block;
    visibility: visible;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Chrome/Safari/Opera */
    -khtml-user-select: none; /* Konqueror */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  not supported by any browser */
}

label.cool-radio > input[type="radio"][disabled] + div,
label.cool-radio > input[type="radio"].disabled + div,
label.cool-radio > input[type="radio"]:disabled + div {
    opacity: 0.65;
    cursor: initial;
}

label.cool-radio > input[type="radio"].cool-hide + div,
label.cool-radio > input[type="radio"]:global(.cool-hide) + div {
    display: none;
}

label.cool-radio > input[type="radio"]:checked + div {
    background-position: 0px -16px;
}
</style>

<script>
export default {
    name: "cool-radio",
};
</script>
